import { render, staticRenderFns } from "./OptionTable.vue?vue&type=template&id=2f556178"
import script from "./OptionTable.vue?vue&type=script&lang=ts"
export * from "./OptionTable.vue?vue&type=script&lang=ts"
import style0 from "./OptionTable.vue?vue&type=style&index=0&id=2f556178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports